@if (isMultiLanguage()) {
  <div [ngClass]="'language selected-' + getCurrentLanguage()" dropdown>
    <button
      [core-analytics]="{ action: 'toggle-dropdown', block }"
      class="btn btn--topnav-dropmenu-selector"
      dropdownToggle>
      <div class="language-icon-wrapper">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 5.35774C8.33158 5.35774 5.35774 8.33158 5.35774 12C5.35774 15.6684 8.33158 18.6423 12 18.6423C15.6684 18.6423 18.6423 15.6684 18.6423 12C18.6423 8.33158 15.6684 5.35774 12 5.35774ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
            fill="#1A1A1A" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4 12.0002C4 11.5093 4.30394 11.1113 4.67887 11.1113H19.3211C19.6961 11.1113 20 11.5093 20 12.0002C20 12.4911 19.6961 12.8891 19.3211 12.8891H4.67887C4.30394 12.8891 4 12.4911 4 12.0002Z"
            fill="#1A1A1A" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9999 4C12.1879 4 12.3672 4.08022 12.4939 4.22102C14.4083 6.34731 15.4962 9.10669 15.5553 11.9859C15.5555 11.9953 15.5555 12.0047 15.5553 12.0141C15.4962 14.8933 14.4083 17.6527 12.4939 19.779C12.3672 19.9198 12.1879 20 11.9999 20C11.8119 20 11.6326 19.9198 11.5058 19.779C9.59151 17.6527 8.5036 14.8933 8.44448 12.0141C8.44429 12.0047 8.44429 11.9953 8.44448 11.9859C8.5036 9.10669 9.59151 6.34731 11.5058 4.22102C11.6326 4.08022 11.8119 4 11.9999 4ZM9.78274 12C9.83271 14.2859 10.6148 16.4859 11.9999 18.2722C13.385 16.4859 14.1671 14.2859 14.217 12C14.1671 9.71409 13.385 7.51414 11.9999 5.72775C10.6148 7.51414 9.83271 9.71409 9.78274 12Z"
            fill="#1A1A1A" />
        </svg>
      </div>
      <span class="topnav-dropmenu">
        @if (isMultiLanguage()) {
          <div [innerText]="getLanguageName(getCurrentLanguage()) | translate" class="topnav-dropmenu__name"></div>
        }
      </span>
    </button>
    <div
      *dropdownMenu
      aria-labelledby="basic-link"
      class="dropdown-menu dropdown-menu--language"
      id="basic-link-dropdown"
      role="menu">
      @for (language of languages$; track language) {
        <div class="language-radio-item">
          <button
            class="language-radio-label"
            [ngClass]="{ active: language.code === getCurrentLanguage() }"
            [attr.aria-label]="`${'Select language: ' + language.name}` | translate"
            (click)="setLanguage(language)"
            (keydown.enter)="setLanguage(language)">
            <span class="language-radio-custom"></span>
            <span [innerText]="language.name | translate" class="language-item__name"></span>
          </button>
        </div>
      }
    </div>
  </div>
}

@if (isMultiLanguage() && !isLargeBreakpoint) {
  <div [innerText]="getLanguageName(getCurrentLanguage()) | translate" class="language-current text-uppercase"></div>
}

<ng-template #languageSelect>
  <div class="modal-header language-modal-header">
    <h5>{{ 'Select your language' | translate }}</h5>
  </div>
  <div class="modal-body">
    @for (language of languages$; track language) {
      <div [ngClass]="{ active: language.code === '' }" class="mb-3">
        <a
          (click)="setLanguage(language)"
          [core-analytics]="{ action: language.name, block }"
          [innerText]="language.name"
          class="btn btn--country"
          href="javascript:void(0)"></a>
      </div>
    }
  </div>
</ng-template>

<!--  <button-->
<!--    *ngIf="!isLargeBreakpoint"-->
<!--    [core-analytics]="{ action: 'toggle-dropdown', block }"-->
<!--    class="language-btn"-->
<!--    dropdownToggle-->
<!--  >-->
<!--    <div class="language-icon-wrapper">-->
<!--      <svg-->
<!--        width="24"-->
<!--        height="24"-->
<!--        viewBox="0 0 24 24"-->
<!--        fill="none"-->
<!--        xmlns="http://www.w3.org/2000/svg"-->
<!--      >-->
<!--        <path-->
<!--          fill-rule="evenodd"-->
<!--          clip-rule="evenodd"-->
<!--          d="M12 5.35774C8.33158 5.35774 5.35774 8.33158 5.35774 12C5.35774 15.6684 8.33158 18.6423 12 18.6423C15.6684 18.6423 18.6423 15.6684 18.6423 12C18.6423 8.33158 15.6684 5.35774 12 5.35774ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"-->
<!--          fill="#1A1A1A"-->
<!--        />-->
<!--        <path-->
<!--          fill-rule="evenodd"-->
<!--          clip-rule="evenodd"-->
<!--          d="M4 12.0002C4 11.5093 4.30394 11.1113 4.67887 11.1113H19.3211C19.6961 11.1113 20 11.5093 20 12.0002C20 12.4911 19.6961 12.8891 19.3211 12.8891H4.67887C4.30394 12.8891 4 12.4911 4 12.0002Z"-->
<!--          fill="#1A1A1A"-->
<!--        />-->
<!--        <path-->
<!--          fill-rule="evenodd"-->
<!--          clip-rule="evenodd"-->
<!--          d="M11.9999 4C12.1879 4 12.3672 4.08022 12.4939 4.22102C14.4083 6.34731 15.4962 9.10669 15.5553 11.9859C15.5555 11.9953 15.5555 12.0047 15.5553 12.0141C15.4962 14.8933 14.4083 17.6527 12.4939 19.779C12.3672 19.9198 12.1879 20 11.9999 20C11.8119 20 11.6326 19.9198 11.5058 19.779C9.59151 17.6527 8.5036 14.8933 8.44448 12.0141C8.44429 12.0047 8.44429 11.9953 8.44448 11.9859C8.5036 9.10669 9.59151 6.34731 11.5058 4.22102C11.6326 4.08022 11.8119 4 11.9999 4ZM9.78274 12C9.83271 14.2859 10.6148 16.4859 11.9999 18.2722C13.385 16.4859 14.1671 14.2859 14.217 12C14.1671 9.71409 13.385 7.51414 11.9999 5.72775C10.6148 7.51414 9.83271 9.71409 9.78274 12Z"-->
<!--          fill="#1A1A1A"-->
<!--        />-->
<!--      </svg>-->
<!--    </div>-->
<!--  </button>-->
